// extracted by mini-css-extract-plugin
export default {"container":"reachOutStyle_container__e92P8","reachoutText":"reachOutStyle_reachoutText__vNa3w","cardItem":"reachOutStyle_cardItem__xIGEz"};